<kendo-treeview
    *ngIf="!ttDraggable && !ttLoadMoreItems && !ttUseDataSourceDirective"
    class="col-xs-12 sp-0"
    [nodes]="ttData"
    [textField]="$any(ttDataName)"
    kendoTreeViewFlatDataBinding
    [idField]="$any(ttDataId)"
    [parentIdField]="$any(ttDataParentId)"
    kendoTreeViewExpandable
    [expandBy]="$any(ttDataId)"
    [(expandedKeys)]="expandedIds"
    (expandedKeysChange)="onExpandedChange($event)"
    [kendoTreeViewSelectable]="ttSelectable"
    [trackBy]="trackBy"
    [filter]="ttFilter"
    [selectBy]="$any(ttDataId)"
    [(selectedKeys)]="selectedIds"
    (selectedKeysChange)="onSelectedChange($event)"
    kendoTreeViewLoadMore
    [pageSize]="pageSize"
>
    <ng-template kendoTreeViewNodeTemplate let-dataItem>
        <ng-container *ngTemplateOutlet="treeItem; context: { $implicit: dataItem }"></ng-container>
    </ng-template>
</kendo-treeview>
<kendo-treeview
    *ngIf="ttDraggable && !ttLoadMoreItems && !ttUseDataSourceDirective"
    class="col-xs-12 sp-0"
    [nodes]="ttData"
    textField="text"
    kendoTreeViewFlatDataBinding
    [idField]="$any(ttDataId)"
    [parentIdField]="$any(ttDataParentId)"
    kendoTreeViewExpandable
    [expandBy]="$any(ttDataId)"
    [(expandedKeys)]="expandedIds"
    (expandedKeysChange)="onExpandedChange($event)"
    [kendoTreeViewSelectable]="ttSelectable"
    [trackBy]="trackBy"
    [filter]="ttFilter"
    [selectBy]="$any(ttDataId)"
    [(selectedKeys)]="selectedIds"
    (selectedKeysChange)="onSelectedChange($event)"
    kendoTreeViewDragAndDrop
    kendoTreeViewDragAndDropEditing
    (nodeDrop)="handleDrop($event)"
>
    <ng-template kendoTreeViewNodeTemplate let-dataItem>
        <ng-container *ngTemplateOutlet="treeItem; context: { $implicit: dataItem }"></ng-container>
        <!-- <span [ngStyle]="style['node']">
            <span [ngStyle]="{ color: dataItem[ttDataIconColor] }" [ngClass]="getIconClasses(dataItem[ttDataIcon])"></span>
            <span> {{ dataItem[ttDataName] }} </span>
        </span> -->
    </ng-template>
    <ng-template kendoTreeViewDragClueTemplate let-action="action" let-destinationItem="destinationItem" let-text="text">
        <span class="k-drag-status k-font-icon k-icon" [ngClass]="getDragStatusIcon(action, destinationItem)"></span>
        <span>{{ text }}</span>
    </ng-template>
</kendo-treeview>
<!-- kendoTreeViewFlatDataBinding -->
<kendo-treeview
    *ngIf="!ttDraggable && !!ttLoadMoreItems && !ttUseDataSourceDirective"
    class="col-xs-12 sp-0"
    [nodes]="ttData"
    [children]="$any(ttChildren)"
    [textField]="$any(ttDataName)"
    kendoTreeViewExpandable
    [expandBy]="$any(ttDataId)"
    [(expandedKeys)]="expandedIds"
    (expandedKeysChange)="onExpandedChange($event)"
    [kendoTreeViewSelectable]="ttSelectable"
    [trackBy]="trackBy"
    [filter]="ttFilter"
    [selectBy]="$any(ttDataId)"
    [(selectedKeys)]="selectedIds"
    (selectedKeysChange)="onSelectedChange($event)"
    [kendoTreeViewLoadMore]="ttLoadMoreItems"
    [hasChildren]="$any(ttHasChildren)"
    [totalField]="$any(ttDataTotalField)"
    [totalRootNodes]="ttTotalRootNodes"
    [pageSize]="ttPageSize"
>
    <ng-template kendoTreeViewNodeTemplate let-dataItem>
        <ng-container *ngTemplateOutlet="treeItem; context: { $implicit: dataItem }"></ng-container>
    </ng-template>
</kendo-treeview>
<!-- *ngIf="!!ttDraggable && !!ttLoadMoreItems && !!service" -->
<kendo-treeview
    *ngIf="ttUseDataSourceDirective"
    class="col-xs-12 sp-0"
    kendoTreeViewExpandable
    [expandBy]="$any(ttDataId)"
    [(expandedKeys)]="expandedIds"
    (expandedKeysChange)="onExpandedChange($event)"
    [kendoTreeViewSelectable]="ttSelectable"
    [trackBy]="trackBy"
    [selectBy]="$any(ttDataId)"
    [(selectedKeys)]="selectedIds"
    (selectedKeysChange)="onSelectedChange($event)"
    kendoTreeViewDragAndDrop
>
    <ng-template kendoTreeViewNodeTemplate let-dataItem>
        <ng-container *ngTemplateOutlet="treeItem; context: { $implicit: dataItem }"></ng-container>
    </ng-template>
</kendo-treeview>

<ng-template #treeItem let-dataItem>
    <span class="tt-tree-view__item" [ngStyle]="style['node']">
        <span [ngStyle]="{ color: dataItem[ttDataIconColor] }" [ngClass]="getIconClasses(dataItem[ttDataIcon])"></span>
        <span class="tt-tree-item__text"> {{ dataItem[ttDataName] }} </span>
    </span>
</ng-template>
